import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, GuardResult, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AmplitudeExperimentAction } from '@actions/amplitde-experiment';
import { InformationsForm } from '../pages/main-form/forms/informations/form/informations-form.form';
import { MiddlewareService } from '../pages/main-form/forms/middleware/middleware.service';

@Injectable({ providedIn: 'root' })
export class MiddlewareRedirectGuard implements CanActivate {
  private router = inject(Router);
  private shouldHandleAbTestAction = inject(AmplitudeExperimentAction);
  private informationsForm = inject(InformationsForm);
  private middlewareService = inject(MiddlewareService);

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<GuardResult> {
    const directCheckout = state.url.includes('direct_checkout');

    const ABTEST_variant = await this.shouldHandleAbTestAction.getVariantByExperimentKey('self-sale-incentive');

    if (
      (ABTEST_variant || directCheckout) &&
      sessionStorage.getItem('middleware-viewed') !== 'true'
    ) {
      sessionStorage.setItem('middleware-viewed', 'true');

      const { deal_id } = this.informationsForm.values || {};

      this.middlewareService
        .systemUsage('experiment_selfcheckout_assignment', deal_id, { variant: ABTEST_variant ? 'treatment' : 'control' })
        .subscribe();

      this.router.navigate(['middleware']);
      return false;
    }

    return true;
  }
}
